/**
 * Remington 700. 7.62 mm bolt action: slowest cycle here, and the scope that meaningfully zooms.
 */

import type { WeaponSpec } from '@/sim/weapons/weaponContract';

export const REMINGTON700 = {
  id: 'remington700',
  label: 'Remington 700',
  classId: 'sniper',
  caliber: '7.62x51 mm',
  fireMode: 'bolt',
  roundsPerMinute: 45,
  magSize: 5,
  reserveAmmo: 30,
  reloadSeconds: 3,
  emptyReloadSeconds: 3.8,
  reloadStyle: 'magazine',
  damage: 120,
  damageTypeId: 'ballistic',
  falloff: { fullMetres: 150, zeroMetres: 600, minScale: 0.6 },
  pellets: 1,
  adsSpreadMoa: 0.6,
  hipSpreadMoa: 300,
  bloomMoaPerShot: 0,
  bloomMoaCap: 0,
  bloomDecayMoaPerSecond: 0,
  moveSpreadMoaPerMps: 55,
  crouchSpreadScale: 0.45,
  airborneSpreadMoa: 240,
  recoilPattern: [
    { pitch: 3.2, yaw: 0.12 },
    { pitch: 3.15, yaw: -0.14 },
  ],
  recoilResetSeconds: 1.2,
  recoilRecoveryPerSecond: 4,
  adsFovDegrees: 20,
  adsSeconds: 0.4,
  adsSensitivityScale: 0.3,
  muzzleVelocity: 850,
} as const satisfies WeaponSpec;
